export default __webpack_public_path__ + "static/media/about.56698f99.png";